import React from "react";
import { PUMAMetricHelper } from "@amzn/dolphin-web-framework";
import { ErrorView } from "@amzn/dolphin-uiweb-framework";
import { Logger } from "@amzn/dolphin-web-framework";
import { NativeMeshInteractor } from "@amzn/dolphin-web-framework";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.log("ErrorBoundary", error, errorInfo);
    //TODO: Implement metrics and loggers
    // Logger.log.fatal("ErrorBoundary", error, errorInfo);
    // const metricName = "clientError";
    // PUMAMetricHelper.publishCountToDolphinCSM(metricName);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <ErrorView
          errorMessage={"vsa.error"}
          title={"Vehicle Safety Audit"}
          onBackClicked={NativeMeshInteractor.exitModule}
        />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
